import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "menu-item px-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menu-content d-flex align-items-center px-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card w-50" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://doptor.sicip.gov.bd/",
        target: "_blank",
        class: "card-body text-center"
      }, " ADMIN PANEL ")
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}